import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";


const TermsConditions = () => {
  const navigate = useNavigate();

  return (
    <div className="font-satoshi max-w-6xl mx-auto px-6 py-14 text-gray-800">
     <button
        onClick={() => navigate("/")}
        className="absolute top-4 left-4 text-gray-600 border border-gray-300 rounded-full p-2 hover:text-[#21A6E9] hover:bg-gray-100 transition-all duration-200"
        aria-label="Back"
      >
        <ArrowLeft className="w-5 h-5" />
      </button>
      <div className="flex justify-between mb-8">
        <h1 className="text-3xl font-bold mb-6 text-center">
          Terms Conditions
        </h1>

        <p className="text-base text-center mt-1 -ml-2">
          Effective Date: 01/05/2025
        </p>
      </div>

      <p className="mb-6 space-y-1 text-base  ">
        Welcome to the official website of BCV Claimpro Assist Pvt. Ltd. ("the
        Company"). This Terms of Use Policy ("Agreement") is an electronic
        record in accordance with the Information Technology Act, 2000, and the
        rules made thereunder, including provisions pertaining to electronic
        records and electronic contracts. This Agreement does not require any
        physical or digital signature and is a legally binding document between
        the User ("you"/"your") and the Company.
      </p>

      {/* Section 1 */}
      <section className="mb-6 space-y-1 text-base">
        <h2 className="text-xl text-[#21A6E9] font-semibold mb-2">
          1.Acceptance of Terms
        </h2>
        <p className=" space-y-1 text-base">
          By accessing, browsing, or using this website, its mobile application,
          or any related services (collectively, the "Platform"), you
          acknowledge that you have read, understood, and agreed to be bound by
          these Terms of Use, along with our Privacy Policy, and any other legal
          and administrative policies published by the Company. If you do not
          agree with these terms, please refrain from using the Platform.
        </p>
        {/* <ul className="list-disc pl-6 mt-2 space-y-1 text-base">
          <li>Visitors</li>
          <li>Registered users</li>
          <li>Third-party service providers</li>
        </ul>
        <p className="mt-2">
          It is governed by Indian laws including the <strong>Information Technology Act, 2000</strong>, and the <strong>DPDPA, 2023</strong> (once enforced).
        </p> */}
      </section>

      {/* Section 2 */}
      <section className="mb-6 space-y-1 text-base">
        <h2 className="text-xl text-[#21A6E9] font-semibold mb-2">
          2.Amendment of Terms
        </h2>
        <p className="text-base">
          The Company reserves the right to modify or amend these Terms of Use
          at any time without prior notice. Continued access or use of the
          Platform following any such modifications constitutes your acceptance
          of the updated terms. Users are encouraged to periodically review this
          page for the latest information.
        </p>
      </section>

      {/* Section 3 */}
      <section className="mb-6 space-y-1 text-base">
        <h2 className="text-xl text-[#21A6E9] font-semibold mb-2">
          3.Eligibility
        </h2>
        <p className="text-base">
          Use of the Platform and services is available only to persons who are
          competent to enter into a legally binding contract under the Indian
          Contract Act, 1872. Persons who are minors (under the age of 18), or
          otherwise disqualified (including but not limited to those declared of
          unsound mind or insolvent), are not eligible to use the services
          unless under the supervision of a parent or legal guardian.
        </p>
      </section>

      {/* Section 4 */}
      <section className="mb-6 space-y-1 text-base">
        <h2 className="text-xl text-[#21A6E9] font-semibold mb-2">
          4.Permitted Use
        </h2>
        <h3 className="text-sm">
          You agree to use the Platform and its services solely for lawful
          purposes. You must not:
        </h3>
        <ul className="list-disc pl-6 mt-1 space-y-1">
          <li>
            Attempt to gain unauthorized access to the Platform or its servers,
            systems, or networks
          </li>
          <li>
            Use any device or software that interferes with the proper working
            of the Platform.
          </li>
          <li>Introduce any viruses, worms, malware, or harmful code.</li>
          <li>
            Violate any applicable laws, rules, or regulations in connection
            with your use.
          </li>
        </ul>
      </section>

      {/* Section 5 */}
      <section className="mb-6 space-y-1 text-base">
        <h2 className="text-xl text-[#21A6E9] font-semibold mb-2">
          5. Privacy
        </h2>
        <p className="text-base">
          Our collection, use, and sharing of your personal information is
          governed by our Privacy Policy [insert hyperlink], which forms an
          integral part of these Terms of Use. By using the Platform, you
          consent to the terms of the Privacy Policy.
        </p>
      </section>

      {/* Section 6 */}
      <section className="mb-6 space-y-1 text-base">
        <h2 className="text-xl text-[#21A6E9] font-semibold mb-2">
          6. Intellectual Property
        </h2>
        <p>
          <p className="mb-6 text-base">
            All content on the Platform, including but not limited to text,
            images, graphics, logos, audio, video, software, and interface
            design, is the exclusive intellectual property of{" "}
            <strong>BCV Claimpro Assist Pvt. Ltd.</strong>, protected by
            applicable copyright and trademark laws. Unauthorized use,
            reproduction, modification, or distribution of any content without
            prior written permission is strictly prohibited.
          </p>
        </p>
      </section>

      {/* Section 7 */}
      <section className="mb-6 space-y-1 text-base">
        <h2 className="text-xl text-[#21A6E9] font-semibold mb-2">
          7. Disclaimer of Warrantiesn
        </h2>
        <p>
          The Platform and its contents are provided on an “as is” and “as
          available” basis without warranties of any kind, whether express or
          implied. The Company does not warrant the accuracy, completeness,
          reliability, or availability of any content or services. Your use of
          the Platform is at your sole risk.
        </p>
      </section>

      {/* Section 8 */}
      <section className="mb-6 space-y-1 text-base">
        <h2 className="text-xl text-[#21A6E9] font-semibold mb-2">
          8. Limitation of Liability
        </h2>
        <p className="text-base">
          To the fullest extent permitted by applicable law, the Company shall
          not be liable for any direct, indirect, incidental, special, punitive,
          or consequential damages, including loss of profits, data, or business
          interruption, arising out of or in connection with your use of or
          inability to use the Platform or services
        </p>
      </section>

      {/* Section 9 */}
      <section className="mb-6 space-y-1 text-base">
        <h2 className="text-xl text-[#21A6E9] font-semibold mb-2">
          9. Governing Law and Jurisdiction
        </h2>
        <p>
          These Terms of Use shall be governed by and construed in accordance
          with the laws of India. Any disputes arising under these terms shall
          be subject to the exclusive jurisdiction of the competent courts
          located in Gurgaon, Haryana, India. In matters related to insurance
          services, the regulations of the Insurance Regulatory and Development
          Authority of India (IRDAI) shall also apply, where applicable.
        </p>
      </section>

      {/* Section 10 */}
      <section className="mb-6 space-y-1 text-base">
        <h2 className="text-xl text-[#21A6E9] font-semibold mb-2">
          10. Governing Entity
        </h2>
        <p>
          This Platform is owned and operated by BCV Claimpro Assist Pvt. Ltd.,
          a company duly incorporated under the Companies Act, 2013, with its
          registered office located at: G-236, 2nd Floor, Sector 57, Gurgaon –
          122003, Haryana, India. By merely using or transacting on the
          Platform, you are entering into a contractual agreement with BCV
          Claimpro Assist Pvt. Ltd., and agree to be bound by the terms herein
          and those referenced by hyperlink.
        </p>
      </section>

      {/* Section 11 */}
      <section className="mb-6 ">
        <h2 className="text-xl text-[#21A6E9] font-semibold mb-2">
         11. Contact Us
        </h2>
        <div className="space-y-1 text-base">
          <div>
            <strong>BCV Claimpro Assist Pvt. Ltd.</strong>
          </div>
          <div>
            Address: G-236, 2nd Floor, Sector 57, Gurgaon – 122003, Haryana,
            India
          </div>
          <div>
            Email:{" "}
            <a
              href="mailto:info@claimpro.in"
              className="!text-[#21A6E9] underline font-medium hover:!text-[#21A6E9] visited:!text-[#21A6E9]"
            >
              info@claimpro.in
            </a>
          </div>
          <div>Working Hours: Monday to Saturday, 10:00 AM to 6:00 PM IST</div>
        </div>
      </section>
    </div>
  );
};

export default TermsConditions;
